import { useState, useEffect } from 'react';
import api from '../api';

const ROLES = [
  { value: 'admin', label: 'Админ' },
  { value: 'accountant', label: 'Бухгалтер' },
  { value: 'manager', label: 'Менеджер' },
  { value: 'rop', label: 'РОП' },
  { value: 'designer', label: 'Дизайнер' },
];

function UserModal({ user, onClose, onSaved }) {
  const isEdit = !!user;
  const [name, setName] = useState(user?.name || '');
  const [email, setEmail] = useState(user?.email || '');
  const [role, setRole] = useState(user?.role || 'manager');
  const [telegram, setTelegram] = useState(user?.telegram || '');
  const [vkId, setVkId] = useState(user?.vk_id || '');
  const [isActive, setIsActive] = useState(user?.is_active ?? true);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setSaving(true);
    try {
      if (isEdit) {
        const payload = { name, email, role, telegram: telegram || null, vk_id: vkId || null, is_active: isActive };
        if (password) payload.password = password;
        await api.patch(`/users/${user.id}`, payload);
      } else {
        if (!password) { setError('Укажите пароль'); setSaving(false); return; }
        await api.post('/users', { name, email, role, telegram: telegram || null, vk_id: vkId || null, password });
      }
      onSaved();
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка сохранения');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-header">
          <h2>{isEdit ? 'Редактировать пользователя' : 'Новый пользователь'}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        {error && <div className="error-msg">{error}</div>}
        <form onSubmit={submit}>
          <div className="form-group">
            <label>Имя *</label>
            <input value={name} onChange={e => setName(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>Email *</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Роль *</label>
              <select value={role} onChange={e => setRole(e.target.value)}>
                {ROLES.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>ВКонтакте</label>
              <input value={vkId} onChange={e => setVkId(e.target.value)} placeholder="ссылка vk.com/id123456 или просто числовой id" />
            </div>
          </div>
          <div className="form-group">
            <label>Telegram</label>
            <input value={telegram} onChange={e => setTelegram(e.target.value)} placeholder="@username" />
          </div>
          <div className="form-group">
            <label>{isEdit ? 'Новый пароль (оставьте пустым, чтобы не менять)' : 'Пароль *'}</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} minLength={8} />
          </div>
          {isEdit && (
            <div className="form-group">
              <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <input type="checkbox" style={{ width: 'auto' }} checked={isActive} onChange={e => setIsActive(e.target.checked)} />
                Активен
              </label>
            </div>
          )}
          <div className="modal-actions">
            <button type="button" className="btn-secondary" onClick={onClose}>Отмена</button>
            <button type="submit" className="btn-primary" disabled={saving}>{saving ? 'Сохранение...' : 'Сохранить'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default function Users() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);
  const [showNew, setShowNew] = useState(false);

  const load = () => {
    setLoading(true);
    api.get('/users').then(r => setUsers(r.data)).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  return (
    <div>
      <div className="toolbar">
        <h2>Пользователи</h2>
        <div className="toolbar-spacer" />
        <button className="btn-primary btn-sm" onClick={() => setShowNew(true)}>+ Новый пользователь</button>
      </div>
      {loading ? <div className="loading-text">Загрузка...</div> : (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Имя</th><th>Email</th><th>Роль</th><th>Telegram</th><th>ВКонтакте</th><th>Статус</th>
              </tr>
            </thead>
            <tbody>
              {users.map(u => (
                <tr key={u.id} className="row-clickable" onClick={() => setEditing(u)}>
                  <td>{u.name}</td>
                  <td>{u.email}</td>
                  <td>{ROLES.find(r => r.value === u.role)?.label || u.role}</td>
                  <td>{u.telegram || '—'}</td>
                  <td>{u.vk_id || '—'}</td>
                  <td>{u.is_active ? <span className="badge badge-paid">Активен</span> : <span className="badge badge-rejected">Отключён</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {showNew && <UserModal onClose={() => setShowNew(false)} onSaved={() => { setShowNew(false); load(); }} />}
      {editing && <UserModal user={editing} onClose={() => setEditing(null)} onSaved={() => { setEditing(null); load(); }} />}
    </div>
  );
}
